resourcePaths = '{"rootPath":"","assetsPath":""}';function APIModelException(type, message) {
    this.type = name;
    this.message = message;
}